import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import checkSquareIcon from "@phosphor-icons/core/regular/check-square.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const multipleChoiceQuiz: Tool = {
    urlSlug: "multiple-choice-quiz",
    configName: "teacher-tool-multiple-choice-quiz",
    title: () => t`Multiple choice quiz`,
    description: () => t`Create multiple-choice quizzes on a variety of topics`,
    categories: [ToolCategories.Create, ToolCategories.Plan],
    icon: checkSquareIcon,
    color: color.fadedGreen24,
    layout: Layout.Coeditor,
    reportingLabelId: "multiple-choice-assessment",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
        "google-forms",
    ],
    requestedInputs: [
        {
            description: () =>
                t`e.g., the Emancipation Proclamation, Newton's laws of motion`,
            inputKind: "CONTENT_SEARCH",
            label: () => t`What is the topic for the quiz?`,
            required: true,
            variableName: "contentDescriptor",
        },
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Grade level`,
            required: true,
            selectOptions: [
                {
                    label: () => t`1st grade`,
                    value: "1st grade",
                },
                {
                    label: () => t`2nd grade`,
                    value: "2nd grade",
                },
                {
                    label: () => t`3rd grade`,
                    value: "3rd grade",
                },
                {
                    label: () => t`4th grade`,
                    value: "4th grade",
                },
                {
                    label: () => t`5th grade`,
                    value: "5th grade",
                },
                {
                    label: () => t`6th grade`,
                    value: "6th grade",
                },
                {
                    label: () => t`7th grade`,
                    value: "7th grade",
                },
                {
                    label: () => t`8th grade`,
                    value: "8th grade",
                },
                {
                    label: () => t`9th grade`,
                    value: "9th grade",
                },
                {
                    label: () => t`10th grade`,
                    value: "10th grade",
                },
                {
                    label: () => t`11th grade`,
                    value: "11th grade",
                },
                {
                    label: () => t`12th grade`,
                    value: "12th grade",
                },
                {
                    label: () => t`College`,
                    value: "College",
                },
            ],
            variableName: "gradeLevel",
        },
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Answer choices`,
            required: true,
            selectOptions: [
                {
                    label: () => t`4 options: a, b, c, d`,
                    value: "1 answer, 3 distractors",
                },
                {
                    label: () => t`5 options: a, b, c, d, e`,
                    value: "1 answer, 4 distractors",
                },
                {
                    label: () => t`2 options: True/False`,
                    value: "the answer options as True/False",
                },
            ],
            variableName: "answerChoices",
        },
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Number of questions`,
            required: true,
            selectOptions: [
                {
                    label: () => t`1`,
                    value: "1",
                },
                {
                    label: () => t`3`,
                    value: "3",
                },
                {
                    label: () => t`5`,
                    value: "5",
                },
                {
                    label: () => t`10`,
                    value: "10",
                },
                {
                    label: () => t`15`,
                    value: "15",
                },
                {
                    label: () => t`20`,
                    value: "20",
                },
            ],
            variableName: "numberOfQuestions",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                renderer="quiz"
                debugMode={debugMode}
            />
        );
    },
};
